module.exports = __webpack_public_path__ + "static/media/moisture.d019d7d5.png";